import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Grid, TextField } from "@mui/material";
import { alertService, GenericFileCrop, setBackdrop } from "common-frontend-components";
import { postsStore } from "../../../../stores/posts/postsStore";
import { callCreatePostAsync } from "../../../../apis/posts";
import { PhotoUploader, updatePhotosStoreAfterImageProcessing } from "../Photos/PhotoUploader";
import SelectCategory from "../../categories/SelectCategory";
import { callCreatePostCategoryAssociationAsync } from "../../../../apis/postCategoryAssociations";
import { postCategoryAssociationsStore } from "../../../../stores/posts/usePostCategoryAssociationsStore";
import { callUploadPhotoAsync } from "../../../../apis/photos";
import { textColor } from "../../../../assets/styles/colors";
import { postCardStyle, textFieldStyle } from "../../../../assets/styles/styles";
import { CreatePostLinks } from "./CreatePostLinks";
import { OrderPhotos } from "../Photos/OrderPhotos";
import { photosStore } from "../../../../stores/posts/usePhotosStore";
import SelectProduct from "../../products/product/SelectProduct";
import { callCreateProductPostAssociationAsync } from "../../../../apis/productPostAssociations";
import { productPostAssociationsStore } from "../../../../stores/products/productPostAssociationsStore";
import { IndexInput } from "../../../custom/inputs/IndexInput";
export const handleOnDropWhenFormingNewPost = (files) => {
    postsStore.setNewPost({ ...postsStore.getNewPost(), files });
};
const createPost = async ({ title, description, links, index }) => {
    const post = await callCreatePostAsync({ title, description, links, index });
    postsStore.setPosts([post, ...postsStore.getPosts()]);
    return post;
};
const createPostCategoryAssociations = async ({ categories }, postId) => {
    const postCategoryAssociations = [];
    for (const i of categories) {
        try {
            postCategoryAssociations.push(await callCreatePostCategoryAssociationAsync({ categoryId: i.id, postId }));
        }
        catch (e) {
            alertService.error(e);
        }
        finally {
            postCategoryAssociationsStore.setPostCategoryAssociations([...postCategoryAssociations, ...postCategoryAssociationsStore.getPostCategoryAssociations()]);
        }
    }
};
const createProductPostAssociations = async ({ products }, postId) => {
    const productPostAssociations = [];
    for (const i of products) {
        try {
            productPostAssociations.push(await callCreateProductPostAssociationAsync({ productId: i.id, postId }));
        }
        catch (e) {
            alertService.error(e);
        }
        finally {
            productPostAssociationsStore.setProductPostAssociations([...productPostAssociations, ...productPostAssociationsStore.getProductPostAssociations()]);
        }
    }
};
export const createPostImages = async (items, postId) => {
    const photos = [];
    for (const i of items) {
        console.log('starting upload', { PostImageItem: i });
        const res = await callUploadPhotoAsync(i.file, {
            contentType: i.file.type,
            postId,
            index: i.index,
            phototype: i.phototype,
        });
        console.log('upload complete!', { res });
        const photo = await updatePhotosStoreAfterImageProcessing(res);
        if (photo !== null) {
            photos.push(photo);
        }
    }
    if (photos.length > 0) {
        const photoLists = [...photosStore.getPhotos()];
        for (let i = 0; i < photoLists.length; i++) {
            for (const photo of photoLists[i]) {
                if (photo.postId === postId) {
                    photoLists[i] = [...photos, ...photoLists[i]];
                    photosStore.setPhotos(photoLists);
                    return;
                }
                break; // postId is the same for each member in the list
            }
        }
        photosStore.setPhotos([photos, ...photoLists]);
    }
};
export const onCreatePost = async () => {
    const newPost = postsStore.getNewPost();
    if (newPost.files.length > 0 && newPost.preview === undefined)
        return alertService.error("please add a preview image with your files");
    if (newPost.files.length === 0 && newPost.preview !== undefined)
        return alertService.error("you have a preview image but no files to relate");
    setBackdrop(true);
    try {
        const post = await createPost(newPost);
        await createPostCategoryAssociations(newPost, post.id);
        await createProductPostAssociations(newPost, post.id);
        await createPostImages([
            { file: new File([newPost.preview?.file], "preview.png", { type: "image/png", lastModified: Date.now() }), phototype: 'preview', index: '0' },
            ...newPost.files.map((file, index) => ({ file, index: `${index + 1}`, phototype: 'fullview' }))
        ], post.id);
        postsStore.clearNewPost();
    }
    catch (e) {
        alertService.error(e);
    }
    finally {
        setBackdrop(false);
    }
};
const CreateLinks = () => _jsx(CreatePostLinks, { links: postsStore.useNewPostLinks(), setLinks: postsStore.setNewPostLinks }, void 0);
export const PreviewImg = ({ preview, setPreview }) => _jsx(GenericFileCrop, { render: ({ selectFile }) => _jsx(Box, { onClick: selectFile, sx: { width: 285, height: 175 }, children: preview ? _jsx(Box, { component: 'img', sx: { width: '100%', height: '100%', cursor: 'pointer' }, src: preview?.imageSrc || preview?.url || "", alt: "click to change preview image" }, void 0) : _jsx(Button, { sx: { width: '100%', height: '100%' }, variant: 'contained', children: "click to add a preview image" }, void 0) }, void 0), aspect: 285 / 175, onImage: setPreview, width: 285, height: 175 }, void 0);
export const CreatePost = () => {
    const title = postsStore.useNewPostTitle();
    const description = postsStore.useNewPostDescription();
    const preview = postsStore.useNewPostPreviewImg();
    const index = postsStore.useNewPostIndex();
    return (_jsx(Box, { sx: { minWidth: 275 }, children: _jsxs(Card, { variant: "outlined", elevation: 3, sx: postCardStyle, children: [_jsxs(CardContent, { children: [_jsx(Typography, { sx: { fontSize: 16, paddingBottom: 2, color: textColor }, color: "text.secondary", gutterBottom: true, children: "New Post" }, void 0), _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, children: _jsx(TextField, { sx: textFieldStyle, label: "title", variant: "outlined", value: title, onChange: postsStore.handleNewPostTitleChange }, void 0) }, void 0), _jsx(Grid, { item: true, xs: 12, children: _jsx(TextField, { sx: textFieldStyle, label: "Sol number", variant: "outlined", value: description, onChange: postsStore.handleNewPostDescriptionChange, fullWidth: true, multiline: true }, void 0) }, void 0), _jsx(Grid, { item: true, xs: 12, children: _jsx(CreateLinks, {}, void 0) }, void 0), _jsx(Grid, { item: true, xs: 12, children: _jsx(PreviewImg, { preview: preview, setPreview: postsStore.setNewPostPreviewImg }, void 0) }, void 0), _jsx(OrderPhotos, { useItems: postsStore.useNewPostFiles, setItems: postsStore.setNewPostFiles, parent: ({ children }) => _jsx(Grid, { item: true, xs: 12, children: children }, void 0) }, void 0), _jsx(Grid, { item: true, children: _jsx(PhotoUploader, { onDrop: handleOnDropWhenFormingNewPost, usePreviewFiles: postsStore.useNewPostFiles, setPreviewFiles: postsStore.setNewPostFiles }, void 0) }, void 0), _jsx(Grid, { item: true, xs: 12, children: _jsx(SelectProduct, {}, void 0) }, void 0), _jsx(Grid, { item: true, xs: 12, children: _jsx(SelectCategory, {}, void 0) }, void 0), _jsx(Grid, { item: true, xs: 12, children: _jsx(IndexInput, { index: index, onIndexChange: postsStore.setNewPostIndex }, void 0) }, void 0)] }, void 0)] }, void 0), _jsx(CardActions, { children: _jsx("div", { style: { paddingLeft: 4, paddingRight: 4 }, children: _jsx(Button, { size: "small", onClick: onCreatePost, children: "Create Post" }, void 0) }, void 0) }, void 0)] }, void 0) }, void 0));
};
//# sourceMappingURL=CreatePost.js.map